import React, { useState, useEffect } from 'react';
import Card from '../../components/Card/Card';
import Input from '../../components/Input/Input';
import Select from '../../components/Select/Select';
import Button from '../../components/Button/Button';
import { FiSave, FiAlertTriangle, FiGlobe, FiTool, FiCreditCard } from 'react-icons/fi';
import api from '../../api';
import './Settings.css';

const Settings = ({ showAlert, showConfirm }) => {
  const [loading, setLoading] = useState(false);
  const [saveStatus, setSaveStatus] = useState('');
  
  const [fineConfig, setFineConfig] = useState({
    FinePerDay: 2.0,
    MaxFine: 100.0,
    IssueLimit: 5,
    BorrowPeriod: 14
  });

  /* ── Initial Fetch ── */
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await api.get('/rules.php');
        const data = res.data;
        if (data && data.RuleId) {
          setFineConfig(prev => ({
            ...prev,
            FinePerDay: data.FinePerDay,
            MaxFine: data.MaxFine,
            BorrowPeriod: data.BorrowPeriod || 14
          }));
        }

      } catch (err) {
        console.error("Failed to fetch fine rules.");
      }
    };
    fetchSettings();
  }, []);

  const handleFineSave = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSaveStatus('');
    try {
      const res = await api.post('/rules.php', {
        FinePerDay: fineConfig.FinePerDay,
        MaxFine: fineConfig.MaxFine,
        BorrowPeriod: fineConfig.BorrowPeriod
      });
      const result = res.data;
      if (result.status === 'success') {
        showAlert("Success", "Library rules have been updated globally.", "success");
        setSaveStatus('fine');
        setTimeout(() => setSaveStatus(''), 3000);
      }
    } catch (err) {
      showAlert("Update Failed", "Could not save configuration settings.", "confirm");
    } finally {
      setLoading(false);
    }
  };


  return (
    <div className="settings-page">
      <div className="page-header">
        <div>
          <h2 className="page-header__title">Configuration</h2>
          <p className="page-header__sub">Global library rules and system settings</p>
        </div>
      </div>

      <div className="settings-grid">
        {/* Fine Configuration */}
        <Card padding="md">
          <Card.Header>
            <Card.Title><FiCreditCard style={{marginRight:8}} /> Fine & Rules</Card.Title>
            <Card.Subtitle>Configure late fee logic and borrowing limits (If you are not taking fines, set fine per day and max fine as 0)</Card.Subtitle>
          </Card.Header>
          <form onSubmit={handleFineSave}>
            <div className="settings-form" style={{marginTop:'20px'}}>
              <Input 
                id="fine-per-day" label="Fine Per Day (₹)" type="number" step="0.5" 
                value={fineConfig.FinePerDay} 
                onChange={(e) => setFineConfig(p => ({...p, FinePerDay: e.target.value}))} 
              />
              <Input 
                id="max-fine" label="Maximum Fine (₹)" type="number" 
                value={fineConfig.MaxFine} 
                onChange={(e) => setFineConfig(p => ({...p, MaxFine: e.target.value}))} 
              />
              {/* <Input 
                id="issue-limit" label="Max Books Per Member" type="number" 
                value={fineConfig.IssueLimit} 
                onChange={(e) => setFineConfig(p => ({...p, IssueLimit: e.target.value}))} 
              /> */}
              <Input 
                id="borrow-period" label="Default Borrow Period (days)" type="number" 
                value={fineConfig.BorrowPeriod} 
                onChange={(e) => setFineConfig(p => ({...p, BorrowPeriod: e.target.value}))} 
              />
            </div>
            <div style={{marginTop:'var(--space-6)', display:'flex', alignItems:'center', gap:'12px'}}>
              <Button type="submit" variant="primary" loading={loading} icon={<FiSave />}>Apply Configuration</Button>
              {saveStatus === 'fine' && <span className="settings-saved-inline">✓ Rules updated successfully</span>}
            </div>
          </form>
        </Card>

        {/* Library Identity */}
        <Card padding="md">
          <Card.Header>
            <Card.Title><FiGlobe style={{marginRight:8}} /> Library Identity</Card.Title>
            <Card.Subtitle>Public information and branding</Card.Subtitle>
          </Card.Header>
          <div className="settings-form" style={{marginTop:'20px'}}>
            <Input id="lib-name"    label="Library Name" defaultValue="Dr. SS Johl Library Management System"  />
            <Input id="lib-email"   label="Admin Email" type="email" defaultValue="info@assmcollege.org"  />
            {/* <div className="form-grid form-grid--2">
               <Select id="lib-timezone" label="Timezone" options={[{ value: 'ist', label: 'IST (+5:30)' }]} defaultValue="ist" />
               <Select id="lib-lang" label="System Language" options={[{ value: 'en', label: 'English' }]} defaultValue="en" />
            </div> */}
          </div>
          {/* <div style={{marginTop:'var(--space-6)'}}>
             <Button variant="secondary">Update Details</Button>
          </div> */}
        </Card>

        {/* System Operations */}
        {/* <Card padding="md">
           <Card.Header>
              <Card.Title><FiTool style={{marginRight:8}} /> Maintenance</Card.Title>
              <Card.Subtitle>System health and data management</Card.Subtitle>
           </Card.Header>
           <div className="settings-toggles" style={{marginTop:'20px'}}>
             {[
               { label: 'Auto-Calculate Fines', sub: 'Enable real-time calculation on returns', enabled: true },
               { label: 'Notify Overdue', sub: 'Broadcast system alerts on late returns', enabled: true },
               { label: 'Debug Mode', sub: 'Log detailed API operations for support', enabled: false },
             ].map((item) => (
               <div key={item.label} className="settings-toggle-row">
                 <div>
                   <p className="settings-toggle-label">{item.label}</p>
                   <p className="settings-toggle-sub">{item.sub}</p>
                 </div>
                 <label className="toggle-switch">
                   <input type="checkbox" defaultChecked={item.enabled} />
                   <span className="toggle-slider" />
                 </label>
               </div>
             ))}
           </div>
        </Card> */}

        {/* Risks */}
        {/* <Card padding="md" className="settings-danger-card">
          <Card.Header>
            <Card.Title><FiAlertTriangle style={{marginRight:8}} /> Critical Actions</Card.Title>
          </Card.Header>
          <div className="danger-zone" style={{marginTop:'20px'}}>
            <div className="danger-zone__item">
              <div><p className="danger-zone__title">Clear History</p><p className="danger-zone__sub">Deletes all returned transaction records</p></div>
              <Button variant="danger" size="sm">Execute</Button>
            </div>
            <div className="danger-zone__item">
              <div><p className="danger-zone__title">Database Purge</p><p className="danger-zone__sub">Caution: Factory reset library data</p></div>
              <Button variant="danger" size="sm">Factory Reset</Button>
            </div>
          </div>
        </Card> */}
      </div>
    </div>
  );
};

export default Settings;
